<template>
  <div class="flex h-14 w-full items-center justify-center bg-noticebar bg-auto bg-center md:h-12 md:bg-noticebar-md">
    <p
      class="truncate font-bold text-white md:text-2xl"
    >
      <slot />
    </p>
  </div>
</template>
